import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';
import * as _ from 'lodash';

// value - the numeric value to transform into indian amount format. Null or NAN will be returned as "".
// currencySymbol - this will be a prefix symbol for amount. default will be ₹
// decimals - how many decimals will be returned after transform. default will be 2. And -1 will return the exact decimal back.
@Pipe({ name: 'AmountPipe' })
export class AmountPipePipe implements PipeTransform {
  transform(
    value: number | string,
    symbol?: 'plusminus' | 'currency' | '',
    decimals: number = 2,
    ifNan?: string
  ): string {
    if (value == null || isNaN(Number(value)) || value.toString().trim() === '') {
      return ifNan ?? '';
    }

    let num = parseFloat(value.toString());

    // Format number using Indian number system
    let formattedValue = new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(Math.abs(num)); // Use absolute value to avoid issues with "-,234"

    // Remove decimals if they are all zeros
    if (formattedValue.includes('.') && parseFloat(formattedValue.split('.')[1]) === 0) {
      formattedValue = formattedValue.split('.')[0];
    }

    // Fix issue with negative numbers appearing as "-,234.23"
    if (num < 0) {
      formattedValue = `-${formattedValue}`; // Ensure negative sign stays correctly positioned
    }

    // Apply symbol logic
    if (symbol === 'plusminus') {
      return num < 0 ? `(${Math.abs(num)})` : formattedValue;
    } else if (symbol === 'currency') {
      return `₹${formattedValue}`;
    }

    return formattedValue;
  }
}


@Pipe({ name: 'AmountHumanizerPipe' })
export class AmountHumanizerPipePipe implements PipeTransform {
  transform(
    value: number | string,
    symbol?: 'plusminus' | 'currency' | '',
    decimals?: number | null,
    ifNan?: string,
  ): any {
    if (value == null || isNaN(Number(value)) || value.toString().trim() == '') {
      if (ifNan != null) {
        return ifNan;
      } else {
        return '';
      }
    }
    var val = parseFloat(value.toString());
    var output;
    if (isNaN(parseFloat(val.toString())) || val == null || val == undefined) {
      output = '0';
    }
    else {
      if (decimals == null) {
        decimals = 2;
      }
      //max number to be used for decimal 
      // if(14 <= decimals){
      //   decimals = 14;
      // }

      var result = '';
      var sym;
      if (val > 0) {
        if (val >= 10000000) {
          // result = (val / 10000000).toString().split('.')[1];
          result += (val / 10000000);
          sym = ' Cr';
        } else if (val >= 100000) {
          result += (val / 100000);
          sym = ' L';
        } else if (val >= 1000) {
          result += (val / 1000);
          sym = ' K';
        } else if (val >= 0) {
          result += val;
          sym = ' ';
        }
      }
      else {
        if (val <= -10000000) {
          result += (val / 10000000);
          sym = ' Cr';
        } else if (val <= -100000) {
          result += (val / 100000);
          sym = ' Lac';
        } else if (val <= -1000) {
          result += (val / 1000)
          sym = ' K';
        } else if (val <= -0) {
          result += val;
          sym = ' ';
        }
      }

      if (result.split('.')[1] && result.split('.')[1].length < decimals) {
        decimals = result.split('.')[1].length;
      }
      output = Number(result).toFixed(decimals) + sym;
    }
    var returnSymbol = '';
    if (symbol == 'plusminus') {
      if (Math.sign(val) == 1) {
        returnSymbol = '+';
      }
      // The else condition is already handled.
      // else if(Math.sign(val) == -1){
      //   returnSymbol = '-';
      // }
    }
    else if (symbol == 'currency') {
      returnSymbol = '₹';
    }
    if (Number(output.split('.')[1].split(' ')[0]) == 0) {
      output = output.split('.')[0] + ' ' + output.split('.')[1].split(' ')[1];
    }
    return returnSymbol + output;

    // if (symbol == 'plusminus') {
    //   if (Math.sign(val) == -1) {
    //     return '(' + Math.abs(output) + ')';
    //   }
    //   else if(Math.sign(val) == 1){
    //     return Math.abs(output);
    //   }
    // }
    // else if (symbol == 'currency') {
    //   return '₹' + output;
    // }
  }
}

@Pipe({ name: 'AmountFormat' })
export class AmountFormatPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) return '';

    const formatter = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if (value >= 10000000) {
      // Crores
      return formatter.format(value / 10000000) + ' Cr';
    } else if (value >= 100000) {
      // Lakhs
      return formatter.format(value / 100000) + ' lac';
    } else {
      // Below lakh
      return formatter.format(value);
    }
  }
}

@Pipe({ name: 'NumberHighlighterPipe' })
export class NumberHighlighterPipePipe implements PipeTransform {
  transform(
    value: number | string,
    compareValue?: number | string
  ): any {
    if (value == null || value == undefined || isNaN(Number(value)) || Number(value) == 0) {
      return '';
    }
    if (compareValue == null || compareValue == undefined || isNaN(Number(compareValue)) || Number(compareValue) == 0) {
      compareValue = 0;
    }

    var val = parseFloat(value.toString());
    var output;
    if (isNaN(parseFloat(val.toString())) || val == null || val == undefined) {
      output = '';
      return output;
    }
    else {
      if (val == Number(compareValue)) {
        output = '';
      }
      else if (val > Number(compareValue)) {
        output = 'fc-clr-status--1';
      }
      else {
        output = 'fc-clr-status--2';
      }
    }
    return output;
  }
}

@Pipe({ name: 'FilterPipe' })
export class FilterPipePipe implements PipeTransform {
  transform(items: any[], search: string, properties: string[]): any {
    if (search == '') {
      return items;
    }
    var splited = search.split(" ");
    for (var i = 0; i < splited.length; i++) {
      // splited[i]='('+splited[i]+'.*?)';
      splited[i] = '' + splited[i] + '.*?';
    }

    var dat1 = splited.join("");
    var dat2 = splited.reverse().join("");
    var searchTerm = new RegExp('(' + dat1 + '|' + dat2 + ')', 'gi');
    return _.filter(items, function (item) {
      let filteredData;
      for (let i = 0; i < properties.length; i++) {
        filteredData = Array.from(item[properties[i]].toString().matchAll(searchTerm)).length > 0;
        if (filteredData == false) {

        }
        else {
          return filteredData;
        }
      }
    })
  }
}

@Pipe({ name: "OrderBy" })
export class OrderByPipe implements PipeTransform {
  transform(
    value: object[],
    orderByCol?: number | string, //index or string
    sortBy?: boolean
  ): any[] {
    if (sortBy) {
      return value.sort(function (a, b) { return a[orderByCol] - b[orderByCol]; })
    }
    else {
      return value.sort(function (a, b) { return b[orderByCol] - a[orderByCol]; })
    }
    // return value.sort((a,b) => a > b);

  }
}
@Pipe({ name: "safe" })
export class SafePipe implements PipeTransform {
  constructor(protected _sanitizer: DomSanitizer) {
  }
  transform(value: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this._sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this._sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this._sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        return this._sanitizer.bypassSecurityTrustHtml(value);
    }
  }
}

@Pipe({ name: 'getLogoPath' })
export class GetLogoPathPipe implements PipeTransform {
  transform(amcId: number | string | null | undefined): string {
    const logoMappings: { [key: string]: string } = {
      1001: 'Axis MF.png',
      1002: 'Baroda BNP Paribas Mutual Fund.png',
      1003: 'Aditya Birla.png',
      1004: 'Baroda BNP Paribas Mutual Fund.png',
      1005: 'Bank of india.png',
      1006: 'canara robeco.png',
      1007: 'DSp favicon.ico',
      1008: 'Edelwiess.png',
      1009: 'quant.png',
      1010: 'Franklin.png',
      1011: 'HDFC MF.png',
      1012: 'hsbc.png',
      1013: 'icici.png',
      1014: 'idbi.png',
      1015: 'BandhanFinancial Holdings Limited.png',
      1016: 'iifcl.png',
      1017: 'IIFL_MF.ico',
      1018: 'IL&FS.png',
      1019: 'groww.png',
      1020: 'jm_financial.png',
      1021: 'Kotak.png',
      1022: 'L&T_Mf.png',
      1023: 'LIC.png',
      1024: 'Mirae.png',
      1025: 'motilal-oswal-mutual-fund.png',
      1026: 'Navi MF.png',
      1027: 'PPFAS.png',
      1029: 'principal.png',
      1030: 'Quantum.png',
      1031: 'Nippon.png',
      1032: 'Invesco.png',
      1033: 'sahara_logo.png',
      1034: 'SBI.png',
      1035: 'Shriram.png',
      1036: 'SREI.png',
      1037: 'Sundaram.png',
      1038: 'Tata.png',
      1039: 'Taurus.png',
      1040: 'Union.png',
      1041: 'UTI.png',
      1042: 'PGIM.jpeg',
      1043: 'Mahindra Manulife.png',
      1044: 'whiteoak-capial--mutual-fund.png',
      1045: 'ITI.png',
      1046: 'pinebridge.webp',
      1047: 'Trust MF.png',
      1048: 'nj-mutual-fund.png',
      1049: 'SAMCO.png',
      1050: 'Bajaj Finserv Mutual Fund.png',
      1051: 'Helios.png',
      1052: 'Zerodha.png',
      1053: 'Old bridge.png',
    };

    // Normalize the input (handle null/undefined and convert to string)
    const normalizedAmcId = amcId?.toString().trim().toLowerCase();

    // Check for null, undefined, or invalid amcId
    if (!normalizedAmcId || isNaN(Number(normalizedAmcId))) {
      return 'Default amc.png';
    }

    // Return the corresponding logo or the default logo if no match is found
    const logo = logoMappings[normalizedAmcId];
    return logo && logo.trim() ? logo : 'Default amc.png';
  }
}

@Pipe({ name: 'getLogoPathScheme' })
export class GetLogoPathBySchemePipe implements PipeTransform {
  transform(schemeName: string): string {
    if (!schemeName) {
      return 'Default amc.png';
    }

    // Extract the first word of the scheme name
    const firstWord = schemeName.split(' ')[0].toLowerCase();

    const logoMappings: { [key: string]: string } = {
      '360': '360 One logo.png',
      'invesco': 'Invesco.png',
      'aditya': 'Aditya Birla.png',
      'axis': 'Axis MF.png',
      'bajaj': 'Bajaj Finserv Mutual Fund.png',
      'bandhan': 'BandhanFinancial Holdings Limited.png',
      'bank': 'BAnk of india.png',
      'bnp': 'Baroda BNP Paribas Mutual Fund.png',
      'baroda': 'Baroda BNP Paribas Mutual Fund.png',
      'canara': 'canara robeco.png',
      'dsp': 'DSp favicon.ico',
      'edelweiss': 'Edelwiess.png',
      'franklin': 'Franklin.png',
      'groww': 'groww.png',
      'hdfc': 'HDFC MF.png',
      'helios': 'Helios.png',
      'hsbc': 'hsbc.png',
      'icici': 'icici.png',
      'idbi': 'idbi.png',
      'iifcl': 'iifcl.png',
      'il&fs': 'IL&FS.png',
      'iti': 'ITI.png',
      'jm': 'jm_financial.png',
      'kotak': 'Kotak.png',
      'lic': 'LIC.png',
      'mahindra': 'Mahindra Manulife.png',
      'mirae': 'Mirae.png',
      'motilal': 'motilal-oswal-mutual-fund.png',
      'navi': 'Navi MF.png',
      'nippon': 'Nippon.png',
      'nj': 'nj-mutual-fund.png',
      'old': 'Old bridge.png',
      'pgim': 'PGIM.jpeg',
      'pinebridge': 'pinebridge.webp',
      'parag': 'PPFAS.png',
      'ppfas': 'PPFAS.png',
      'principal': 'principal.png',
      'quant': 'quant.png',
      'quantum': 'Quantum.png',
      'sahara': 'sahara_logo.png',
      'samco': 'SAMCO.png',
      'sbi': 'SBI.png',
      'shriram': 'Shriram.png',
      'srei': 'SREI.png',
      'sundaram': 'Sundaram.png',
      'tata': 'Tata.png',
      'taurus': 'Taurus.png',
      'trust': 'Trust MF.png',
      'union': 'Union.png',
      'uti': 'UTI.png',
      'whiteoak': 'whiteoak-capial--mutual-fund.png',
      'woc': 'whiteoak-capial--mutual-fund.png',
      'zerodha': 'Zerodha.png',
      'idfc': 'idfc.png',
    };

    // Check if the first word matches any key in the logoMappings
    return logoMappings[firstWord] || 'Default amc.png';
  }
}
@Pipe({ name: 'getBankLogo' })
export class GetBankLogoPipe implements PipeTransform {

  transform(bankName: string | null | undefined): string {

    // ✅ Handle null / undefined / empty values
    if (!bankName || bankName.trim() === '') {
      return 'bank (1).png';
    }

    const bankNameLowerCase = bankName.toLowerCase();

    const logoMappings: { [key: string]: string } = {
      'axis': 'axis-bank.png',
      'baroda': 'bob-bank.png',
      'union': 'ubi-bank.png',
      'icici': 'ICICI Bank.png',
      'hdfc': 'hdfc-bank.png',
      'kotak': 'Kotak.png',
      'sbi': 'sbi-bank.png',
      'state': 'sbi-bank.png',
      'canara': 'canara-bank.png',
      'yes': 'yes-bank.png',
      'india': 'boi-bank.png',
      'punjab': 'pnb-bank.png',
      'federal': 'federal-bank.png',
      'standard': 'standard-chartered-bank.png',
      'hsbc': 'hsbc-bank.png',
      'citi': 'citi-bank.png',
      'idbi': 'idbi-bank.png',
      'indusind': 'indusInd-bank.png',
    };

    // ✅ Find matching key
    const matchedKey = Object.keys(logoMappings)
      .find(key => bankNameLowerCase.includes(key));

    // ✅ Return mapped logo OR default image
    return matchedKey ? logoMappings[matchedKey] : 'bank (1).png';
  }
}

@Pipe({ name: 'leadingZero' })
export class LeadingZeroPipe implements PipeTransform {
  transform(value: number): string {
    if (value === undefined || value === null) {
      return '';
    }

    if (value === 0) {
      return '0';
    } else if (value >= 1 && value <= 9) {
      return '0' + value.toString();
    } else {
      return value.toString();
    }
  }
}

@Pipe({ name: 'abs' })
export class AbsPipe implements PipeTransform {
  transform(value: any): any {
    if (value === undefined || value === null || isNaN(Number(value))) {
      return value;
    }
    return Math.abs(Number(value));
  }
}

@Pipe({ name: 'XirrPipe' })
export class XirrPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    symbol?: 'plusminus' | '',
    decimals: number = 2,
    ifNan?: string
  ): string {
    if (value == null || isNaN(Number(value)) || value.toString().trim() === '') {
      return ifNan ?? '';
    }

    let num = parseFloat(value.toString());
    let formattedValue = num.toFixed(decimals);

    if (parseFloat(formattedValue) === 0) {
      return '0';
    }

    if (symbol === 'plusminus' && num > 0) {
      return `+${formattedValue}`;
    }

    return formattedValue;
  }
}

